"use client";
import Link from "next/link";
import { ArrowLeft, Home } from "lucide-react";
import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex-center min-h-screen flex-col bg-gray-50 p-4 dark:bg-[#212121]">
      <div className="mx-auto max-w-2xl text-center">
        <h1 className="mb-8 text-9xl font-bold text-gray-400 dark:text-gray-700">
          404
        </h1>
        <h2 className="mb-4 text-3xl font-semibold text-gray-800 md:text-4xl dark:text-gray-200">
          Page Not Found
        </h2>
        <p className="mb-8 text-lg text-gray-600 dark:text-gray-400">
          We&apos;re sorry, but the page you&apos;re looking for doesn&apos;t
          exist or has been moved.
        </p>
        <div className="flex-center flex-col gap-4 sm:flex-row">
          <Link
            href="/"
            className="flex-center rounded-md border border-transparent bg-blue-600 px-6 py-3 text-base font-medium transition duration-150 ease-in-out hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-hidden"
          >
            <Home className="mr-2" size={18} />
            Home
          </Link>
          <button
            onClick={() => router.back()}
            className="flex-center rounded-md border border-gray-300 bg-white px-6 py-3 text-base font-medium text-gray-700 transition duration-150 ease-in-out hover:bg-gray-50 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-hidden dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700"
          >
            <ArrowLeft className="mr-2" size={18} />
            Go Back
          </button>
        </div>
      </div>
      <div className="mt-16 text-sm text-gray-500 dark:text-gray-400">
        &copy;2025 bundled.design. All rights reserved.
      </div>
    </div>
  );
}
